// MIGRAÇÃO PARA EDITOR SIMPLIFICADO
import DocumentEditorNew from "./DocumentEditorNew";

interface DocumentEditorProps {
  document: any;
  content: string;
  onContentChange: (content: string) => void;
  headerContent?: string;
  footerContent?: string;
  onHeaderChange?: (header: string) => void;
  onFooterChange?: (footer: string) => void;
  isBlankDocument?: boolean;
  isAIWriting?: boolean;
  onAIWritingChange?: (writing: boolean) => void;
  streamingContent?: string;
  onStreamToDocument?: (payload: { mode: string; text: string }) => void;
  editPosition?: { start: number; end: number; section?: string };
  onTextSelection?: (text: string, position: { start: number; end: number }) => void;
  aiContent?: string;
  editorVersion?: number;
  onDocumentCreated?: () => void;
  onBack?: () => void;
  onSave?: () => void;
  onDownloadPDF?: () => void;
  onPrint?: () => void;
  onCopy?: () => void;
  isDownloading?: boolean;
}

const DocumentEditor = (props: DocumentEditorProps) => {
  // Redirecionar para o novo editor simplificado
  return <DocumentEditorNew {...props} />;
};

export default DocumentEditor;